import {
  ArrowLongRightIcon,
  Button,
  EyeIcon,
  EyeSlashIcon,
  Input,
  Link,
  LockClosedIcon,
  useAuthStore,
  useCharity,
  useCustomForm,
  UserCircleIcon,
  useState,
} from "@";
import { login } from "./utils/api";
import { loginSchema } from "./utils/validation";

const Login = () => {
  const { setUser } = useAuthStore();
  const { charityName, isLoading } = useCharity();
  const [showPassword, setShowPassword] = useState(false);

  const { errors, register, handleSubmit, isSubmitting, setValue } =
    useCustomForm({}, loginSchema);

  const submit = async (from) => {
    try {
      const { data } = await login(from);
      setUser(data);
      localStorage.removeItem("otpChecked");
      localStorage.removeItem("phoneNumber");
    } catch (error) {}
  };

  return (
    <form className="relative p-6 md:p-8" onSubmit={handleSubmit(submit)}>
      {/* Eyebrow */}
      <p className="text-[11px] font-semibold uppercase tracking-[0.18em] text-purple-700 dark:text-purple-400">
        مرحباً بعودتك
      </p>
      <h2 className="mt-1.5 text-2xl font-bold tracking-tight text-gray-900 dark:text-gray-100 md:text-3xl">
        تسجيل الدخول
      </h2>
      <p className="mt-1 text-sm text-gray-500 dark:text-gray-400">
        أدخل بيانات حسابك للوصول إلى{" "}
        <span className="font-semibold text-purple-700 dark:text-purple-400">
          {isLoading ? "..." : charityName}
        </span>
      </p>

      <div className="mt-7 space-y-4">
        {/* Email */}
        <div className="relative *:mb-12 *:h-14 *:rounded-full">
          <Input
            star
            type="email"
            error={errors.email}
            label="البريد الالكتروني"
            input={register("email")}
            change={(e) => setValue("email", e.target.value)}
            styles="input ps-10 h-14 rounded-full dark:bg-transparent dark:border-gray-500"
          />
          <span
            aria-hidden
            className="pointer-events-none absolute start-3 top-[44px] text-gray-400 dark:text-gray-400"
          >
            <UserCircleIcon className="h-6 w-6" />
          </span>
        </div>

        {/* Password */}
        <div className="relative *:mb-12 *:h-14 *:rounded-full">
          <Input
            star
            dir="ltr"
            label="كلمة المرور"
            error={errors.password}
            input={register("password")}
            type={showPassword ? "text" : "password"}
            change={(e) => setValue("password", e.target.value)}
            styles="input text-start ps-10 pe-10 h-14 rounded-full dark:bg-transparent dark:border-gray-500"
          />
          <span
            aria-hidden
            className="pointer-events-none absolute start-3 top-[44px] text-gray-400 dark:text-gray-400"
          >
            <LockClosedIcon className="h-6 w-6" />
          </span>
          <button
            type="button"
            onClick={() => setShowPassword(!showPassword)}
            aria-label={
              showPassword ? "إخفاء كلمة المرور" : "إظهار كلمة المرور"
            }
            className="absolute end-2 top-[33px] flex h-9 w-9 items-center justify-center rounded-lg text-gray-400 transition-colors hover:bg-gray-50 hover:text-purple-700 dark:text-gray-500 dark:hover:bg-gray-700 dark:hover:text-purple-300"
          >
            {showPassword ? (
              <EyeSlashIcon className="h-6 w-6" />
            ) : (
              <EyeIcon className="h-6 w-6" />
            )}
          </button>
        </div>

        <Button
          type="submit"
          title="تسجيل الدخول"
          isLoading={isSubmitting}
          className="!w-full rounded-full !py-3"
        />

        <div className="flex items-center justify-end">
          <Link
            to="/forget-password"
            className="group/link inline-flex items-center gap-1 text-xs font-semibold tracking-tight text-purple-700 hover:text-purple-900 dark:text-purple-400 dark:hover:text-purple-300"
          >
            نسيت كلمة المرور؟
            <ArrowLongRightIcon className="h-3.5 w-3.5 transition-transform group-hover/link:-translate-x-0.5 rtl:rotate-180" />
          </Link>
        </div>
      </div>
    </form>
  );
};

export default Login;
